/* V2
 Builds a table header, adds base-name to the css classes for customized css
 */
import * as React from "react";
import { map as _map } from "lodash";
import * as moment from "moment";;
export interface ICustomHeaderInfo {
  label: string;
  display: string;
  value?: string;
  mandatory?: boolean;
  colSize?: string;
}
interface CustomHeaderProps {
  headerInfos: ICustomHeaderInfo[];
  rootCls: string;
  additionalCls?: string;
}
class CustomHeader extends React.Component<CustomHeaderProps> {
  constructor(props: CustomHeaderProps) {
    super(props);
  }
  getHeaderDisplay(headerInfo: any) {
    return `${headerInfo.display}${headerInfo.value ? headerInfo.value : ""}`;
  }
  render() {
    let currInstance = this;
    return (
      <div>
        <div className={"smart-header " + this.props.rootCls + "-header"}>
          <div className={"smart-row " + this.props.rootCls + "-row"}>
            {_map(this.props.headerInfos, function(headerInfo, index) {
              return (
                <div
                  className={`smart-column brandon-bold ${
                    currInstance.props.rootCls
                  }-column ${currInstance.props.rootCls}-${
                    headerInfo.label
                  } ${currInstance.props.additionalCls ||
                    ""} ${headerInfo.colSize || ""}`}
                  key={index}
                >
                  {currInstance.getHeaderDisplay(headerInfo)}
                  {headerInfo.mandatory !== undefined &&
                    headerInfo.mandatory && (
                      <span className="mandatory-asterik">*</span>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
export default CustomHeader;
